<script lang="ts">export let size = "20";
const height = size;
</script>

<svg {height} style="fill: currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M16.906 3c.6 0 1.156.297 1.492.786l.08.126 3.016 5.28a1.81 1.81 0 0 1-.189 2.066l-.102.112-8.403 8.403a1.13 1.13 0 0 1-1.509.083l-.091-.083-8.403-8.403a1.81 1.81 0 0 1-.362-2.043l.07-.135 3.017-5.28a1.81 1.81 0 0 1 1.423-.906L7.094 3zM7.739 8.696a.905.905 0 0 0 0 1.28l3.46 3.46a1.13 1.13 0 0 0 1.6 0l3.462-3.46a.905.905 0 1 0-1.28-1.28L12 11.676l-2.98-2.98a.905.905 0 0 0-1.28 0"
	/>
</svg>
